export default __webpack_public_path__ + "static/anticorruption-practices-60adcf2f3e829587d27e4498d0d7ab25.png";